import {
  EntitySwitch,
  isOrphan,
  EntityOrphanWarning,
  hasRelationWarnings,
  EntityRelationWarning,
  hasCatalogProcessingErrors,
  EntityProcessingErrorsPanel,
} from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';

export default (
  <EntitySwitch>
    <EntitySwitch.Case if={isOrphan}>
      <Grid item xs={12}>
        <EntityOrphanWarning />
      </Grid>
    </EntitySwitch.Case>
    <EntitySwitch.Case if={hasRelationWarnings}>
      <Grid item xs={12}>
        <EntityRelationWarning />
      </Grid>
    </EntitySwitch.Case>
    <EntitySwitch.Case if={hasCatalogProcessingErrors}>
      <Grid item xs={12}>
        <EntityProcessingErrorsPanel />
      </Grid>
    </EntitySwitch.Case>
  </EntitySwitch>
);
